import styled from 'styled-components'

export const Container = styled.div`
  background-color: #fff;
  width: 50rem;
  border-radius: 1rem;
  padding: 1.5rem;
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const CloseDiv = styled.div`
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 50%;

  &:hover{
    background-color: #F4F4F4;
  }
`

export const FormData = styled.div`
  margin-top: 1.4rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 1rem;
  row-gap: 1rem;
`

export const InputDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: .3rem;
  width: 100%;
`

export const InputData = styled.input`
  border: none;
  outline: none;
  background-color: #EBEBEB;
  height: 40px;
  padding: 0 1rem;
  border-radius: 2rem;
`

export const SelectData = styled.select`
  width: 100%;
  border: none;
  outline: none;
  background-color: #EBEBEB;
  height: 2.98rem;
  padding: 0 1rem;
  border-radius: 2rem;
`

export const InputLabel = styled.label`
  display: block;
  font-size: 21;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: clamp(0.78rem, calc(0.78rem + 0.1vw) , 1.6rem);
`

export const BottomDiv = styled.div`
  margin-top: 1rem;
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap:1.5rem;
  span{
    color:red;
  }
`

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: end;
  margin-top: 2rem;
  gap: 1rem;
`

export const ButtonDiv = styled.div`
  background-color: #0090D3;
  color: #fff;
  padding: .7rem 1.2rem;
  font-weight: 700;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap:.5rem;
  border-radius: 1.5rem;
  user-select: none;
  cursor: pointer;
  img{
    width: 1rem;
  }
  &.cancel{
    border: 1px solid #0090D3;
    color: #0090D3;
    background-color: #fff;
  }
`

export const DimensionsFieldsDiv = styled.div`
  display: flex;
  gap: 1rem;
`

export const ShortField = styled.input`
  width: 100%;
  border: none;
  outline: none;
  background-color: #EBEBEB;
  height: 2.98rem;
  padding: 0 1rem;
  border-radius: 2rem;
`
export const TabsDiv = styled.div`
  display: flex;
  gap: 1rem;
  max-width: 22rem;
  overflow: auto;
`

export const TabDiv = styled.div`
  border: 1px solid #919191;
  padding: .3rem .8rem;
  background-color: #fff;
  border-radius: .8rem;
  display: flex;
  align-items: center;
  gap: .4rem;
  user-select: none;
  min-width: fit-content;
`

export const TabText = styled.span`
  font-size: .8rem;
`